import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BookCard from './BookCard';
import NoSubjectsAllocatedScreen from '../../pages/errorPages/NoSubjectsAllocated';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { trackEvent } from '../../segment';

const BookListComponent: React.FC = () => {
    const navigate = useNavigate();
    const [isLoaded, setIsLoaded] = useState(false);

    const books = useSelector((state: RootState) => state.books.data);
    const filteredBooks = books.filter(
        (book: { bookdetails: { id: number } }) => book.bookdetails
    );
    useEffect(() => {
        // Set loading to false after the first render
        setIsLoaded(true);
    }, []);
    const handleBookClick = (
        bookId: string,
        bookTitle: string,
        classDivison: string,
        isbn: string
    ) => {
        //old event
        trackEvent('epub_open_clicked', {
            book_title: bookTitle,
            book_id: bookId,
            class_division: classDivison,
        });
        trackEvent('click_book', {});
        if (!bookId) bookId = bookTitle;

        if(isbn && isbn.trim()) navigate(`/book?bookId=${bookId}&userRole=teacher&isbn=${isbn}`);
        else navigate(`/book?bookId=${bookId}&userRole=teacher`);
    };
    const sortedBooks = React.useMemo(() => {
        return [...filteredBooks].sort((obj1: any, obj2: any) => {
            // First, compare by classname
            const className1 = obj1?.classname || '';
            const className2 = obj2?.classname || '';
            const classNameComparison = className1.localeCompare(className2);

            // If classnames are different, return the comparison result
            if (classNameComparison !== 0) {
                return classNameComparison;
            }

            // If classnames are the same, compare by subject_name
            const subjectName1 = obj1?.bookdetails?.subject_name || '';
            const subjectName2 = obj2?.bookdetails?.subject_name || '';
            return subjectName1.localeCompare(subjectName2);
        });
    }, [filteredBooks]);

    if (!isLoaded) {
        // Render Shimmer as API call is not completed
        return null;
    }

    // Render NoSubjectsAllocatedScreen if no books
    if (filteredBooks.length === 0) {
        return <NoSubjectsAllocatedScreen />;
    }

    // Render the list of books
    return (
        <div className="flex items-center flex-wrap gap-10">
            {sortedBooks?.map((book: any) => {
                const isbn =
                    book.isbns && book.isbns.length > 0
                        ? book.isbns[0]?.isbn
                        : '';
                return (
                    <BookCard
                        key={book.uid}
                        title={book.bookdetails?.name}
                        isLocked={book.isLocked}
                        className={book.bookdetails?.class_name}
                        series={book.bookdetails?.series}
                        cover={book.bookdetails?.thumbnail_url}
                        book_url={book.bookdetails?.url}
                        book_id={book.bookdetails?.id}
                        onClick={() =>
                            handleBookClick(
                                book.bookdetails?.id,
                                book.bookdetails?.name,
                                book.bookdetails?.class_name,
                                isbn
                            )
                        }
                    />
                );
            })}
        </div>
    );
};

export default React.memo(BookListComponent);
